module.exports = __webpack_public_path__ + "static/10-35d6807828a60c39773c8c8227249db8.jpeg";